import type { IReviewItem } from '@sravni/react-seo';

import type { ReviewsListParams } from '../__generated__/reviews/reviewsApiTypes';

import { ProxyClient } from './client/ProxyClient';

export const getReviews = async (params: ReviewsListParams) => {
  const { data } = await ProxyClient.get<IReviewItem[]>('/reviews', { params });

  return data;
};
